import ApiClient from "../../../../../../lib/apiClient";
import { GridMetricRequestDTO } from "../types";

class GridMetricsApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  fetchMetrics = async <T>(
    url: string,
    query: string,
    gridViewTitle?: string,
    headers?: Record<string, string>
  ): Promise<T> => {
    const gridMetricRequestDTO = {
      query,
      gridViewTitle,
    } as GridMetricRequestDTO;
    return this._apiClient.post<T>(url, gridMetricRequestDTO, {
      headers,
    });
  };

  fetchMetricOptionValues = async <GridMetricOptionValueReadDTO>(
    url: string,
    headers?: Record<string, string>
  ): Promise<GridMetricOptionValueReadDTO[]> => {
    return this._apiClient.get<GridMetricOptionValueReadDTO[]>(url, {
      headers,
    });
  };
}

export default GridMetricsApiClient;
